module.exports = __webpack_public_path__ + "img/measurement_info_left_neck_back.c517eee4.jpg";